import { FileStatusCollection } from "./../../../import-status/collections/file-status";
import { AdvancedSearchFieldSelectorModel } from "./../../models/advanced-search-field-selector";
import { FieldSelectorEntryView } from "./field-selector-entry";
import { SearchModel } from "./../../models/search";
import Marionette from "../../../shared/marionette-mustache";
import { AdvancedSearchFieldModel } from "../../../search/models/advanced-search-field";
import {backboneViewProperties} from "../../../decorators/backbone-properties";

@backboneViewProperties({
    tagName: "ul",
    className: "dropdown-menu",
    childView : FieldSelectorEntryView
})
export class AdvancedSearchFieldSelectorListView extends Marionette.CollectionView<AdvancedSearchFieldModel, FieldSelectorEntryView> {

    private fieldSelector: AdvancedSearchFieldSelectorModel;

    constructor(selectorModel: AdvancedSearchFieldSelectorModel, options?: any) {
        super(options);
        this.fieldSelector = selectorModel;
        this.listenTo(this.collection, "change:ShowOnForm", this.render);
        this.listenTo(this.fieldSelector, "change:FilterText", this.filterTextChanged);
    }

    public onRender() {
        const visibleFields = this.collection.where((m) => m.ShowOnForm === false && m.FilteredOut === false);
        if (visibleFields.length === 0) {
            $(".field-selector-list-region").hide();
        } else {
            $(".field-selector-list-region").show();
        }
    }

    private filterTextChanged() {
        this.collection.each((f) => {
            f.FilteredOut = true;
            if (f.FieldLabel.toLowerCase().indexOf(this.fieldSelector.FilterText.toLowerCase()) >= 0) {
                f.FilteredOut = false;
            }
        });
        this.render();
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/advanced-search/advanced-search-field-selector-list.ts